// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"84b8bacc","239":"4540152d","455":"02fb4d31"}[chunkId] + ".chunk.js";
};